import {
    TableHead,
    TableRow,
    TableCell,
    TableSortLabel,
    TableContainer,
    Table,
    TableBody
} from '@material-ui/core';
import CircularIndeterminate from '../../../Core/BudgetCore/loader';
import { TextFieldIcon } from '../../../Core/FormInput';
import { useState, useEffect } from 'react';
import formatters from '../../../Core/Grid/inputFormatter';
import { some } from 'lodash';
import { Grid, FormLabel } from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { CSVLink } from "react-csv";

export default function UsedStockReportTable(props) {
    const { StockReportDataTable, updatePrice, openCapPopup, openAutotraderTaxonomyPopup, deleteATRecord } = props;
    const [canEdit, setCanEdit] = useState((localStorage.getItem('_canEditUsedStockReport_') || '').toUpperCase() === 'TRUE' || false);
    const [isAdm, setIsAdm] = useState((localStorage.getItem('_userRoles_') || '').toUpperCase() === 'ADMIN' || false);
    const portalNicolJson = JSON.parse(localStorage.getItem('NicoleFilterData'));
    const [stockData, setStockData] = useState({
        tableData: StockReportDataTable,
        filterTableData: [],
        filterText: ""
    });
    const [loaderVisible, setLoaderVisible] = useState(false);

    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('');

    const [selectTab, setSelectTab] = useState("vehicle");

    const [actionFilter, setActionFilter] = useState('all');
    const [metricsFilter, setMetricsFilter] = useState('all');
    let searchTimer;

    const headCellsFixed = [
        {
            id: "site",
            label: "Site",
            classLabel: "columnSize60"
        },
        {
            id: "regNo",
            label: "Reg No",
            classLabel: "columnSize80"
        },
        {
            id: "make",
            label: "Make",
            classLabel: "columnSize95"
        },
        {
            id: "model",
            label: "Model",
            classLabel: "columnSize200"
        },
        {
            id: "retailPrice",
            label: "Retail Price",
            classLabel: "columnSize80"
        },
        {
            id: "mileage",
            label: "Mileage",
            classLabel: "columnSize80"
        },
        {
            id: "dis",
            label: "DIS",
            classLabel: "columnSize60"
        },
        {
            id: "action",
            label: "Action",
            classLabel: "columnSize80"
        }
    ];

    const headsCellsVehicle = [
        {
            id: "stockNO",
            label: "Stock No",
            classLabel: "columnSize80"
        },
        {
            id: "specification",
            label: "Specification",
            classLabel: "columnSize250"
        },
        {
            id: "transmission",
            label: "Transmission",
            classLabel: "columnSize95"
        },
        {
            id: "fuelType",
            label: "Fuel Type",
            classLabel: "columnSize95"
        },
        {
            id: "colour",
            label: "Colour",
            classLabel: "columnSize95"
        },
        {
            id: "modelCode",
            label: "Model Code",
            classLabel: "columnSize95"
        },
        {
            id: "dor",
            label: "DOR",
            classLabel: "columnSize95"
        },
        {
            id: "inStockDate",
            label: "In Stock Date",
            classLabel: "columnSize95"
        },
        {
            id: "qualifyingForVAT",
            label: "VAT Status",
            classLabel: "columnSize95"
        },
        {
            id: "progressCode",
            label: "Progress Code",
            classLabel: "columnSize95"
        },
        {
            id: "acsStatus",
            label: "ACS Status",
            classLabel: "columnSize95"
        },
        {
            id: "supplier",
            label: "Supplier",
            classLabel: "columnSize120"
        },
    ];

    const headsCellsPrice = [
        {
            id: "pricePosition",
            label: "Price Position",
            classLabel: "columnSize95"
        },
        {
            id: "atPriceIndicator",
            label: "AT Price Indicator",
            classLabel: "columnSize120"
        },
        {
            id: "daysSinceChange",
            label: "Days since change",
            classLabel: "columnSize120"
        },
        {
            id: "noOfChanges",
            label: "No of changes",
            classLabel: "columnSize95"
        },
        {
            id: "lastPriceChange",
            label: "Last price change",
            classLabel: "columnSize120"
        },
        {
            id: "totalPriceChange",
            label: "Total price change",
            classLabel: "columnSize120"
        },
        {
            id: "standInValue",
            label: "Keyloop Total SIV",
            classLabel: "columnSize120" 
        },
        {
            id: "total",
            label: "Total (Chassis + Prep) ex VAT",
            classLabel: "columnSize120" 
        },
        {
            id: "margin",
            label: "Margin",
            classLabel: "columnSize95" 
        }
    ];

    const headsCellsValuation = [
        {
            id: "atRetailValue",
            label: "AT Retail Value",
            classLabel: "columnSize120"
        },
        {
            id: "atVariance",
            label: "AT Variance",
            classLabel: "columnSize120"
        },
        {
            id: "capClean",
            label: "CAP Clean",
            classLabel: "columnSize120"
        },
        {
            id: "capVariance",
            label: "CAP Variance",
            classLabel: "columnSize120"
        },
        {
            id: "standInValue",
            label: "Keyloop Total SIV",
            classLabel: "columnSize120"
        },
        {
            id: "daysToSell",
            label: "Days to Sell",
            classLabel: "columnSize95"
        },
        // {
        //     id: "forecastValuation",
        //     label: "Forecast Valuation",
        //     classLabel: "columnSize120"
        // },
        {
            id: "capId",
            label: "Cap Code",
            classLabel: "columnSize80"
        }
    ];

    const headsCellsMarket = [
        {
            id: "atRetailRating",
            label: "AT Retail Rating",
            classLabel: "columnSize95"
        },
        {
            id: "atPerformanceRating",
            label: "AT Performance Rating",
            classLabel: "columnSize150"
        },
        {
            id: "atPriceIndicator",
            label: "AT Price Indicator",
            classLabel: "columnSize120"
        },
        {
            id: "daysToSell",
            label: "Days to Sell",
            classLabel: "columnSize95"
        },
        {
            id: "marketCondition",
            label: "Market Condition",
            classLabel: "columnSize120"
        },
        {
            id: "attentionGrabber",
            label: "Attention Grabber",
            classLabel: "columnSize120"
        },
        {
            id: "photos",
            label: "Photos",
            classLabel: "columnSize80"
        },
        {
            id: "atAdvertViews",
            label: "AT Advert Views",
            classLabel: "columnSize120"
        },
        {
            id: "atStatus",
            label: "AT Status",
            classLabel: "columnSize95"
        },
        {
            id: "taxonomyCheck",
            label: "AT Taxonomy",
            classLabel: "columnSize95"
        },
        {
            id: "atLink",
            label: "AT Link",
            classLabel: "columnSize95"
        },
        // {
        //     id: "chorleyLink",
        //     label: "Chorley Group Link",
        //     classLabel: "columnSize120"
        // }
    ];

    const headsCellsPrep = [
        {
            id: "estDate",
            label: "Date Pushed",
            classLabel: "columnSize120"
        },
        {
            id: "vehiclePrep",
            label: "Vehicle Prepped",
            classLabel: "columnSize120"
        },
        {
            id: "daysToPrep",
            label: "Days To Prep",
            classLabel: "columnSize120"
        },
        {
            id: "estimatedMechPrep",
            label: "Estimated Mech Prep",
            classLabel: "columnSize150"
        },
        {
            id: "actualMechPrep",
            label: "Actual Mech Prep",
            classLabel: "columnSize150"
        },
        {
            id: "estimatedBodywork",
            label: "Estimated  Body Work",
            classLabel: "columnSize150"
        },
        {
            id: "actualBodywork",
            label: "Actual Body Work",
            classLabel: "columnSize150"
        },
        {
            id: "motExpiry",
            label: "MOT Expiry Date",
            classLabel: "columnSize150"
        }
    ];

    const headsCellsActions = [
        {
            id: "noPrice",
            label: "No Price",
            classLabel: "columnSize80"
        },
        {
            id: "noPhotos",
            label: "No Photos",
            classLabel: "columnSize80"
        },
        {
            id: "noMileage",
            label: "No Mileage",
            classLabel: "columnSize100"
        },
        {
            id: "toPrep",
            label: "Not Prepped",
            classLabel: "columnSize80"
        },
        {
            id: "noPrepPush",
            label: "No Prep Push",
            classLabel: "columnSize80"
        },
        {
            id: "priceChange",
            label: "Price Change",
            classLabel: "columnSize80"
        },
        {
            id: "noTaxonomy",
            label: "Taxonomy Check",
            classLabel: "columnSize120"
        },
        {
            id: "reserved10+Days",
            label: "Reserved 3+ Days",
            classLabel: "columnSize120"
        },
    ];

    const popupHeads = [
        {
            key: "site",
            label: "Site",
        },
        {
            key: "regNo",
            label: "Reg No",
        },
        {
            key: "make",
            label: "Make",
        },
        {
            key: "model",
            label: "Model",
        },
        {
            key: "franchise",
            label: "Franchise"
        },
        {
            key: "retailPrice",
            label: "Retail Price",
        },
        {
            key: "mileage",
            label: "Mileage",
        },
        {
            key: "dis",
            label: "DIS",
        },
		{
            key: "stockNO",
            label: "Stock No",
        },
        {
            key: "specification",
            label: "Specification",
        },
        {
            key: "transmission",
            label: "Transmission",
        },
        {
            key: "fuelType",
            label: "Fuel Type",
        },
        {
            key: "colour",
            label: "Colour",
        },
        {
            key: "modelCode",
            label: "Model Code",
        },
        {
            key: "dor",
            label: "DOR",
        },
        {
            key: "inStockDate",
            label: "In Stock Date",
        },
        {
            key: "deliveryDate",
            label: "DeliveryDate",
        },
        {
            key: "qualifyingForVAT",
            label: "VAT Status",
        },
        {
            key: "progressCode",
            label: "Progress Code",
        },
		{
            key: "pricePosition",
            label: "Price Position",
        },
        {
            key: "atPriceIndicator",
            label: "AT Price Indicator",
        },
        {
            key: "daysSinceChange",
            label: "Days since change",
        },
        {
            key: "noOfChanges",
            label: "No of changes",
        },
        {
            key: "lastPriceChange",
            label: "Last price change",
        },
        {
            key: "totalPriceChange",
            label: "Total price change",
        },
        {
            key: "standInValue",
            label: "Keyloop Total SIV",
        },
        {
            key: "total",
            label: "Total (Chassis + Prep) ex VAT",
        },
        {
            key: "margin",
            label: "Margin",
        },
		{
            key: "atRetailValue",
            label: "AT Retail Value",
        },
        {
            key: "atAdjustedTrade",
            label: "AT Adjusted Trade"
        },
        {
            key: "atAdjustedPartEx",
            label: "AT Adjusted PartEx"
        },
        {
            key: "atVariance",
            label: "AT Variance",
        },
        {
            key: "capClean",
            label: "CAP Clean",
        },
        {
            key: "capVariance",
            label: "CAP Variance",
        },
        {
            key: "daysToSell",
            label: "Days to Sell",
        },
        {
            key: "acsStatus",
            label: "ACS Status",
        },
        {
            key: "supplier",
            label: "Supplier",
        },
        {
            key: "capId",
            label: "Cap Code",
        },
		{
            key: "atRetailRating",
            label: "AT Retail Rating",
        },
        {
            key: "atPerformanceRating",
            label: "AT Performance Rating",
        },
        {
            key: "atPriceIndicator",
            label: "AT Price Indicator",
        },
        {
            key: "daysToSell",
            label: "Days to Sell",
        },
        {
            key: "marketCondition",
            label: "Market Condition",
        },
        {
            key: "attentionGrabber",
            label: "Attention Grabber",
        },
        {
            key: "photos",
            label: "Photos",
        },
        {
            key: "atAdvertViews",
            label: "AT Advert Views",
        },
        {
            key: "atStatus",
            label: "AT Status",
        },
        {
            key: "atLink",
            label: "AutoTrader Link",
        },
        // {
        //     key: "chorleyLink",
        //     label: "Chorley Group Link",
        // },
        {
            key: "estDate",
            label: "Date Pushed",
        },
		{
            key: "vehiclePrep",
            label: "Vehicle Prepped",
        },
        {
            key: "daysToPrep",
            label: "Days to Prep",
        },
        {
            key: "estimatedMechPrep",
            label: "Estimated Mech Prep",
        },
        {
            key: "actualMechPrep",
            label: "Actual Mech Prep",
        },
        {
            key: "estimatedBodywork",
            label: "Estimated  Body Work",
        },
        {
            key: "actualBodywork",
            label: "Actual Body Work",
        },
        {
            key: "motExpiry",
            label: "MOT Expiry Date",
        },
		{
            key: "noPrice",
            label: "No Price",
        },
        {
            key: "noPhotos",
            label: "No Photos",
        },
        {
            key: "noAttGrabber",
            label: "No Att Grabber",
        },
        {
            key: "toPrep",
            label: "To Prep",
        },
        {
            key: "priceChange",
            label: "Price Change",
        },
        {
            key: "noCapCode",
            label: "No CAP Code",
        },
        {
            key: "lowLeads",
            label: "Low Leads",
        },
        {
            key: "reserved10+Days",
            label: "Reserved 3+ Days",
        }
    ]

    const extractSiteName = function (name) {
        let site = name.split(' ')[0];
        let brand = name.split(' ')[1];

        let siteBrand = site[0] + site[1] + site[2] + "-" + brand[0];

        return siteBrand.toUpperCase();
    };

    const setFilterText = (e) => {
        const vl = e.target.value;
        setStockData((st) => ({ ...st, filterText: vl }));
        searchTimer && clearTimeout(searchTimer);
        searchTimer = setTimeout(() => {
            setFilteredRow();
        }, 500);

        localStorage.setItem('NicoleFilterData', JSON.stringify({ ...portalNicolJson, tableFilter: vl }));
    };

    const setFilteredRow = () => {
        setStockData((st) => {
            const newSt = { ...st };
            const { filterText, tableData } = newSt;
            let filterd = [];
            filterd = [...tableData];

            if (filterText.trim().length > 0) {
                filterText
                    .trim()
                    .split(' ')
                    .map((t) => t.trim().toLowerCase())
                    .forEach((src) => {
                        filterd = filterd.filter((rw) => some(rw, (vl) => `${vl}`.toLowerCase().includes(src)));
                    });
            }
            newSt.filterTableData = filterd;
            return newSt;
        });
    };

    const actionFilterHandler = (e) => {
        let type = e.target.value;
        setActionFilter(type);
        
        var hireCar = ["HIRECAR", "HIRECOMM", "LTHIRE", "RUNACAR", "RUNACOM"];

        if (type === "all") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                
                newSt.filterTableData = filterd;
                return newSt;
            });
        }
        
        if (type === "noPrice") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];

                filterd = filterd.filter((rw) => rw.noPrice && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "noPhotos") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];

                filterd = filterd.filter((rw) => rw.noPhotos && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "noMileage") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];

                filterd = filterd.filter((rw) => rw.mileage === 0 && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "toPrep") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];

                filterd = filterd.filter((rw) => rw.toPrep && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "priceChange") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.priceChange && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "noMileage") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.noMileage && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "noPrepPush") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];

                filterd = filterd.filter((rw) => rw.noPrepPush && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "reserved") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.reserved10 && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "noTaxonomy") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.taxonomyCheck === "Not checked" && !hireCar.includes(rw.modelCode) && rw.progressCode !== "R");
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "7Days") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.prepType === "7Days" && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }
        
        if (type === "7-14Days") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.prepType === "7-14Days" && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "14+Days") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.prepType === "14+Days" && !hireCar.includes(rw.modelCode));
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        setTimeout(function(){
            setLoaderVisible(false);
        }, 200);
    }

    const metricsFilterHandler = (e) => {
        let type = e.target.value;
        setMetricsFilter(type);
        setLoaderVisible(true);

        if (type === "all" || type === "" ) {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                filterd = [...tableData];
                
                newSt.filterTableData = filterd;
                return newSt;
            });
        }
        
        if (type === "published" || type === "notInAt" || type === "none" || type === "reservedMargin") {
            var status = type === "published" ? "Published" : type === "none" ? "None" : type === "reservedMargin" ? "Reserved" : "";

            if (type === "published" || type === "none" || type === "reservedMargin") {
                setStockData((st) => {
                    const newSt = { ...st };
                    const { tableData } = newSt;
                    let filterd = [];
                    filterd = [...tableData];
    
                    filterd = filterd.filter((rw) => rw.atStatus === status);
                    newSt.filterTableData = filterd;
                    return newSt;
                });
            }
            else
            {
                setStockData((st) => {
                    const newSt = { ...st };
                    const { tableData } = newSt;
                    let filterd = [];
                    filterd = [...tableData];
    
                    filterd = filterd.filter((rw) => rw.atStatus === "Not on AT" || rw.atStatus === "Not Published");
                    newSt.filterTableData = filterd;
                    return newSt;
                });
            }
        }

        if (type === "priceLow" || type === "priceGreat" || type === "priceGood" || type === "priceFair" || type === "priceHigh" || type === "priceNoAna") {
            var status = type === "priceLow" ? "LOW" : type === "priceGreat" ? "GREAT" : type === "priceGood" ? "GOOD" : type === "priceFair" ? "FAIR" : type === "priceHigh" ? "HIGH" : type === "priceNoAna" ? "NOANALYSIS" : "";

            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                filterd = [...tableData];

                filterd = filterd.filter((rw) => rw.usedInCalc && rw.atPriceIndicator === status);
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "retail<20" || type === "retail2140" || type === "retail4160" || type === "retail6180" || type === "retail>81") {
            var max = type === "retail<20" ? 20 : type === "retail2140" ? 40 : type === "retail4160" ? 60 : type === "retail6180" ? 80 : type === "retail>81" ? 200 : "";
            var min = type === "retail<20" ? 0 : type === "retail2140" ? 20 : type === "retail4160" ? 40 : type === "retail6180" ? 60 : type === "retail>81" ? 80 : "" ;

            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                filterd = [...tableData];

                filterd = filterd.filter((rw) => rw.usedInCalc && rw.atRetailRating > min && rw.atRetailRating <= max);
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "franchiseRisk") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.franchiseRisk);
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        if (type === "nonFranchiseRisk") {
            setStockData((st) => {
                const newSt = { ...st };
                const { tableData } = newSt;
                let filterd = [];
                newSt.filterTableData = filterd;
                filterd = [...tableData];
                filterd = filterd.filter((rw) => rw.nonFranchiseRisk);
                newSt.filterTableData = filterd;
                return newSt;
            });
        }

        setTimeout(function(){
            setLoaderVisible(false);
        }, 200);
    }

    useEffect(() => {
        setFilteredRow();
    }, [stockData.tableData]);

    const PriceIndicator = (props) => {
        return (
            props.indicator === "GOOD" ? <>
               <span className='priceIndicator good'>{props.indicator}</span>
            </> : 
            props.indicator === "LOW" ? <>
                <span className='priceIndicator low'>{props.indicator}</span>
            </> : 
            props.indicator === "GREAT" ? <>
                <span className='priceIndicator great'>{props.indicator}</span>
            </> : 
            props.indicator === "FAIR" ? <>
                <span className='priceIndicator fair'>{props.indicator}</span>
            </> : 
            props.indicator === "HIGH" ? <>
                <span className='priceIndicator high'>{props.indicator}</span>
            </> : 
            props.indicator === "NOANALYSIS" ? <>
                <span className='priceIndicator noanalysis'>NONE</span>
            </> : <></>
        )
    }

    const PerformanceRating = (props) => {
        return (
            props.indicator === "EXCELLENT" ? <>
               <span className='priceIndicator great'>{props.indicator}</span>
            </> : 
            props.indicator === "ABOVE_AVERAGE" ? <>
                <span className='priceIndicator good'>ABOVE AVERAGE</span>
            </> : 
            props.indicator === "BELOW_AVERAGE" ? <>
                <span className='priceIndicator low'>BELOW AVERAGE</span>
            </> : 
            props.indicator === "NONE" ? <>
                <span className='priceIndicator noanalysis'>{props.indicator}</span>
            </> :
            props.indicator === "LOW" ? <>
                <span className='priceIndicator fair'>{props.indicator}</span>
            </> : <></>
        )
    }

    const RetailRating = (props) => {
        return (
            props.rating > 0 && props.rating <= 100 ? <>
                <span className='yellow'>{props.rating+"/100"}</span>
            </> : <></>
        )
    }

    const getScroll = (e) => {
        const target = e.target;

        localStorage.setItem('NicoleFilterData', JSON.stringify({ ...portalNicolJson, scrollTablePosition: target.scrollTop }));
    }

    const GreenCheck = () => {
        return (
            <>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M6.3335 8.63642L8.11127 10.3334L11.6668 6.93945" stroke="#4F8000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <ellipse cx="9" cy="8.63636" rx="8" ry="7.63636" stroke="#4F8000" strokeWidth="2"/>
                </svg>
            </>
        );
    }

    const RedCheck = () => {
        return (
            <>
                <svg version="1.1" id="Layer_1" width={"18px"} height={"18px"} x="0px" y="0px"
	                viewBox="0 0 332.19 318.79">
                    <g>
                        <g>
                            <path style={{fill: "#BF2B26"}} d="M165.42,311.61c-58.73-2.34-105.85-26.2-137.48-76.9C-5.54,181.07,0.61,109.8,42.05,62.06
                                c35.34-40.71,80.56-59.84,133.9-56.4c59.45,3.83,104.79,32.34,133.38,85.21c12.85,23.75,17.26,49.58,15.88,76.7
                                c-3.3,64.87-51.91,120.5-113.71,137.25c-7.21,1.95-14.52,3.76-21.9,4.83C181.72,310.78,173.69,310.98,165.42,311.61z
                                M290.76,166.2c0.16-39.46-13.86-71.39-37.4-92.46C224.5,47.9,190.74,36.85,152.17,40.79c-30.66,3.13-56.97,15.66-78.29,37.86
                                c-39.3,40.93-43.44,102.08-10.33,146.89c34.55,46.76,98.78,64.38,152.55,40.93C262.99,246.01,288.18,209.89,290.76,166.2z"/>
                            <path style={{fill: "#BF2B26"}} d="M153.28,74.41c8.24,0,16.16,0,24.8,0c-1.44,36.28-2.88,72.26-4.34,108.96c-5.07,0-9.85,0.25-14.57-0.2
                                c-1.01-0.1-2.45-2.72-2.54-4.25c-0.54-8.63-0.73-17.28-1.03-25.92c-0.91-25.6-1.83-51.2-2.73-76.79
                                C152.86,75.72,153.08,75.25,153.28,74.41z"/>
                            <path style={{fill: "#BF2B26"}} d="M165.39,206.78c8.36-0.03,14.58,6.13,14.57,14.41c-0.01,8.06-6.58,14.57-14.64,14.51
                                c-7.99-0.06-14.81-6.78-14.77-14.57C150.58,213.14,157.13,206.81,165.39,206.78z"/>
                        </g>
                    </g>
                </svg>
            </>
        );
    }

    function stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    function getComparator(order, orderBy) {
        return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    const createSortHandler = (property) => (event) => {
        handleRequestSort(event, property);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const csvExportHandler = (data) => {
        data.map(row => {
            row.dor = row.dor !== null && row.dor !== "0001-01-01T00:00:00" ? row.dor.toString().slice(0, 10).split("-").reverse().join("/") : "-";
            row.inStockDate = row.inStockDate !== null && row.inStockDate !== "0001-01-01T00:00:00" ? row.inStockDate.toString().slice(0, 10).split("-").reverse().join("/") : "-";
            row.motExpiry = row.motExpiry !== null && row.motExpiry !== "0001-01-01T00:00:00" ? row.motExpiry.toString().slice(0, 10).split("-").reverse().join("/") : "-";
        });

        return data;
    }

    return (
        <>
            <div className='stockTableHeader'>
                <span className='stockTableHeaderTitle'>STOCK LIST</span>
                <div className='stockTableHeaderTabs'>
                    <span className={selectTab === "vehicle" ? "tableSelectButtons active" : "tableSelectButtons" } onClick={() => setSelectTab("vehicle")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M7.57133 1V20.2M16.4856 9.22857H11.6856M16.4856 5.11429H11.6856M4.14276 5.11429H1.3999M4.14276 9.22857H1.3999M4.14276 13.3429H1.3999M5.51419 20.2H17.857C19.3719 20.2 20.5999 18.972 20.5999 17.4571V3.74286C20.5999 2.22802 19.3719 1 17.857 1H5.51419C3.99935 1 2.77133 2.22802 2.77133 3.74286V17.4571C2.77133 18.972 3.99935 20.2 5.51419 20.2Z" stroke="#4871D9" strokeWidth="2" strokeLinecap="round"/>
                    </svg>Vehicle</span>
                    <span className={selectTab === "price" ? "tableSelectButtons active" : "tableSelectButtons" } onClick={() => setSelectTab("price")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <path d="M15.85 17.1226C15.2209 17.4109 14.5371 17.5602 13.845 17.5602C13.153 17.5602 12.4692 17.4109 11.8401 17.1226C11.1825 16.8956 10.4834 16.8139 9.79115 16.8831C9.09888 16.9523 8.42986 17.1709 7.8302 17.5236C8.2596 17.375 8.63813 17.1078 8.92199 16.753C9.20584 16.3982 9.38342 15.9702 9.43416 15.5187V9.5038C9.43839 8.80121 9.67317 8.11944 10.1024 7.56322C10.5317 7.00699 11.1317 6.60708 11.8103 6.42491C12.4889 6.24274 13.2085 6.28839 13.8586 6.55485C14.5087 6.82131 15.0534 7.29383 15.4089 7.89984M13.3639 12.7117H7.75M22.6 12.5002C22.6 18.4649 17.7647 23.3002 11.8 23.3002C5.83532 23.3002 1 18.4649 1 12.5002C1 6.53552 5.83532 1.7002 11.8 1.7002C17.7647 1.7002 22.6 6.53552 22.6 12.5002Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>Price</span>
                    <span className={selectTab === "valuation" ? "tableSelectButtons active" : "tableSelectButtons" } onClick={() => setSelectTab("valuation")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M1 1V20.2H20.2M5.8 13.0001L10 8.80013L13 11.8001L19.6 5.20013M15.1097 4.6H20.2009V9.69117" stroke="#A59F9F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>Valuation</span>
                    <span className={selectTab === "market" ? "tableSelectButtons active" : "tableSelectButtons" } onClick={() => setSelectTab("market")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
                        <path d="M6 9.86667V8.6M11 9.86667V7.33333M16 9.86667V4.8M8.5 14.9333L6.625 20M15.785 19.9296L13.5753 15.0035M3.5 14.9333C2.11929 14.9333 1 13.7991 1 12.4V3.53333C1 2.13421 2.11929 1 3.5 1H18.5C19.8807 1 21 2.13421 21 3.53333V12.4C21 13.7991 19.8807 14.9333 18.5 14.9333H3.5Z" stroke="#A59F9F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>Market</span>
                    <span className={selectTab === "prep" ? "tableSelectButtons active" : "tableSelectButtons" } onClick={() => setSelectTab("prep")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                        <path d="M21.979 6.1042C21.9629 5.91726 21.5456 5.55826 21.3691 5.49423C21.192 5.4298 20.9939 5.47366 20.8607 5.6061L18.1895 8.2773L14.7199 4.8077L17.4446 2.09331C17.5779 1.9606 17.6214 1.76316 17.5572 1.58712C17.4923 1.41073 17.0645 1.03704 16.8765 1.02085C15.2218 0.878819 13.6004 1.46738 12.4282 2.63536C10.8228 4.23491 10.3976 6.57069 11.1505 8.56166C11.0682 8.63073 10.987 8.70391 10.9069 8.78283L1.81203 17.3325C1.80883 17.3356 1.80566 17.339 1.80219 17.3421C0.732603 18.4077 0.732603 20.1415 1.80219 21.2073C2.87196 22.2728 4.5996 22.2599 5.66901 21.1943C5.67362 21.19 5.67784 21.1857 5.68206 21.1809L14.1892 12.0498C14.2668 11.9722 14.3388 11.891 14.4066 11.8076C16.4057 12.559 18.7518 12.1365 20.3586 10.5359C21.5306 9.3678 22.1218 7.75246 21.979 6.1042Z" stroke="#A59F9F" strokeWidth="2" strokeLinejoin="round"/>
                    </svg>Prep</span>
                    <span className={selectTab === "actions" ? "tableSelectButtons active" : "tableSelectButtons" } onClick={() => setSelectTab("actions")}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                        <path d="M25.7522 14.2353C25.7522 13.683 25.3045 13.2353 24.7522 13.2353C24.1999 13.2353 23.7522 13.683 23.7522 14.2353H25.7522ZM12.8761 3.47059C13.4284 3.47059 13.8761 3.02287 13.8761 2.47059C13.8761 1.9183 13.4284 1.47059 12.8761 1.47059V3.47059ZM19.8142 14.2353C19.8142 13.683 19.3665 13.2353 18.8142 13.2353C18.2619 13.2353 17.8142 13.683 17.8142 14.2353H19.8142ZM12.8761 9.35294C13.4284 9.35294 13.8761 8.90523 13.8761 8.35294C13.8761 7.80066 13.4284 7.35294 12.8761 7.35294V9.35294ZM18.8284 9.50929C19.2208 9.12061 19.2238 8.48745 18.8351 8.09509C18.4464 7.70273 17.8133 7.69975 17.4209 8.08843L18.8284 9.50929ZM12.1723 13.2877C11.78 13.6764 11.777 14.3096 12.1657 14.7019C12.5544 15.0943 13.1875 15.0973 13.5799 14.7086L12.1723 13.2877ZM26 5.15945L26.7038 5.86988C26.9736 5.60255 27.0687 5.2054 26.9492 4.84484C26.8297 4.48427 26.5162 4.22254 26.1401 4.16932L26 5.15945ZM21.2763 9.83883L20.9627 10.7884C21.3198 10.9063 21.7129 10.8139 21.9801 10.5493L21.2763 9.83883ZM17.0775 5.67938L16.3737 4.96895C16.1027 5.23743 16.008 5.63673 16.1297 5.9983L17.0775 5.67938ZM21.8012 1L22.7909 0.857266C22.737 0.483449 22.4771 0.171895 22.119 0.0518536C21.7609 -0.0681874 21.3657 0.0237669 21.0974 0.289569L21.8012 1ZM18.1272 8.79897L17.1794 9.11789C17.2798 9.4162 17.5147 9.64985 17.8136 9.74854L18.1272 8.79897ZM22.326 4.63952L21.3363 4.78225C21.3997 5.22214 21.7458 5.56738 22.1859 5.62965L22.326 4.63952ZM23.7522 14.2353C23.7522 20.1716 18.8917 25 12.8761 25V27C19.9785 27 25.7522 21.2939 25.7522 14.2353H23.7522ZM12.8761 25C6.8605 25 2 20.1716 2 14.2353H0C0 21.2939 5.77374 27 12.8761 27V25ZM2 14.2353C2 8.29898 6.8605 3.47059 12.8761 3.47059V1.47059C5.77374 1.47059 0 7.17668 0 14.2353H2ZM17.8142 14.2353C17.8142 16.9229 15.6122 19.1176 12.8761 19.1176V21.1176C16.699 21.1176 19.8142 18.0452 19.8142 14.2353H17.8142ZM12.8761 19.1176C10.14 19.1176 7.93806 16.9229 7.93806 14.2353H5.93806C5.93806 18.0452 9.05324 21.1176 12.8761 21.1176V19.1176ZM7.93806 14.2353C7.93806 11.5477 10.14 9.35294 12.8761 9.35294V7.35294C9.05324 7.35294 5.93806 10.4254 5.93806 14.2353H7.93806ZM17.4209 8.08843L12.1723 13.2877L13.5799 14.7086L18.8284 9.50929L17.4209 8.08843ZM25.2962 4.44902L20.5725 9.1284L21.9801 10.5493L26.7038 5.86988L25.2962 4.44902ZM17.7812 6.38981L22.5049 1.71043L21.0974 0.289569L16.3737 4.96895L17.7812 6.38981ZM21.5899 8.88926L18.4407 7.8494L17.8136 9.74854L20.9627 10.7884L21.5899 8.88926ZM19.075 8.48005L18.0252 5.36046L16.1297 5.9983L17.1794 9.11789L19.075 8.48005ZM20.8114 1.14273L21.3363 4.78225L23.3158 4.49679L22.7909 0.857266L20.8114 1.14273ZM22.1859 5.62965L25.8599 6.14959L26.1401 4.16932L22.4661 3.64939L22.1859 5.62965Z" fill="#A59F9F"/>
                    </svg>Actions</span>
                </div>
                <div style={{position: "relative"}}>
                    <div className='exportCSVButton custom'>
                        <CSVLink data={csvExportHandler(stockData.filterTableData)} headers={popupHeads} target="_blank" filename={"StockList.csv"}>
                            DOWNLOAD CSV  
                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="19" viewBox="0 0 27 19" fill="none">
                                <path d="M4.9624 11.8455L4.9624 14.5457C4.9624 14.955 5.18504 15.3474 5.58135 15.6368C5.97765 15.9262 6.51515 16.0887 7.07561 16.0887H19.7549C20.3153 16.0887 20.8528 15.9262 21.2491 15.6368C21.6454 15.3474 21.8681 14.955 21.8681 14.5457V11.8455M13.4164 2.91016V11.6537M13.4164 11.6537L18.2466 8.31286M13.4164 11.6537L8.58622 8.31286" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </CSVLink>
                    </div>
                </div>
                <div className='stockTableHeaderFilters'>
                    <TextFieldIcon className="customTextBox" required name="Search" label="Search" onChange={setFilterText} value={stockData.filterText} /> 
                    <Grid item className='filterTopPage'>
                        <FormLabel className='labelInput'>
                            Action Filter
                        </FormLabel>
                        <Select 
                            className='customSelectFilterSingle'
                            onChange={actionFilterHandler}
                            value={actionFilter}
                            id="actionFilter"
                            name="actionFilter"
                        >
                            <MenuItem value={"all"}>All</MenuItem>
                            <MenuItem value={"noPrice"}>No Price</MenuItem>
                            <MenuItem value={"noPhotos"}>No Photos</MenuItem>
                            <MenuItem value={"noMileage"}>No Mileage</MenuItem>
                            <MenuItem value={"toPrep"}>Not Prepped</MenuItem>
                            <MenuItem value={"noPrepPush"}>No Prep Push</MenuItem>
                            <MenuItem value={"7Days"}>7 Days</MenuItem>
                            <MenuItem value={"7-14Days"}>7-14 Days</MenuItem>
                            <MenuItem value={"14+Days"}>14+ Days</MenuItem>
                            <MenuItem value={"priceChange"}>Price Change</MenuItem>
                            <MenuItem value={"reserved"}>Reserved 3+ Day</MenuItem>
                            <MenuItem value={"noTaxonomy"}>Taxonomy Check</MenuItem>
                        </Select>

                        <input type="hidden" onClick={actionFilterHandler} value="noPhotos" id="noPhotosInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="noMileage" id="noMileageInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="toPrep" id="toPrepInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="priceChange" id="priceChangeInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="noPrice" id="noPriceInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="noCapCode" id="noCapCodeInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="noPrepPush" id="noPrepPushInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="reserved" id="reserved10Day" />
                        <input type="hidden" onClick={actionFilterHandler} value="noTaxonomy" id="noTaxonomyInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="7Days" id="7DaysInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="7-14Days" id="7-14DaysInput" />
                        <input type="hidden" onClick={actionFilterHandler} value="14+Days" id="14+DaysInput" />
                    </Grid>
                    <Grid item className='filterTopPage'>
                        <FormLabel className='labelInput'>
                            Metrics
                        </FormLabel>
                        <Select 
                            className='customSelectFilterSingle'
                            onChange={metricsFilterHandler}
                            value={metricsFilter}
                            id="metricsFilter"
                            name="metricsFilter"
                        >
                            <MenuItem value={"all"}>All</MenuItem>
                            <MenuItem value={"published"}>Published</MenuItem>
                            <MenuItem value={"notInAt"}>Not on AT/Not Published</MenuItem>
                            <MenuItem value={"none"}>None</MenuItem>
                            <MenuItem value={"reservedMargin"}>Reserved</MenuItem>
                            <MenuItem value={""}><span className='bold'>Franchise</span></MenuItem>
                            <MenuItem value={"franchiseRisk"}>- Franchise Risk</MenuItem>
                            <MenuItem value={"nonFranchiseRisk"}>- Non Franchise Risk</MenuItem>
                            <MenuItem value={""}><span className='bold'>Price Indicator</span></MenuItem>
                            <MenuItem value={"priceLow"}>- Low</MenuItem>
                            <MenuItem value={"priceGreat"}>- Great</MenuItem>
                            <MenuItem value={"priceGood"}>- Good</MenuItem>
                            <MenuItem value={"priceFair"}>- Fair</MenuItem>
                            <MenuItem value={"priceHigh"}>- High</MenuItem>
                            <MenuItem value={"priceNoAna"}>- No Analysis</MenuItem>
                            <MenuItem value={""}><span className='bold'>Retail Rating</span></MenuItem>
                            <MenuItem value={"retail<20"}>- 20</MenuItem>
                            <MenuItem value={"retail2140"}>- 21-40</MenuItem>
                            <MenuItem value={"retail4160"}>- 41-60</MenuItem>
                            <MenuItem value={"retail6180"}>- 61-80</MenuItem>
                            <MenuItem value={"retail>81"}>- 81</MenuItem>
                        </Select>

                        <input type="hidden" onClick={metricsFilterHandler} value="published" id="publishedInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="none" id="notPublishedInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="notInAt" id="notInAtInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="reservedMargin" id="reservedMarginInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="priceLow" id="priceLowInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="priceGreat" id="priceGreatInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="priceGood" id="priceGoodInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="priceFair" id="priceFairInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="priceHigh" id="priceHighInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="priceNoAna" id="priceNoAnaInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="retail<20" id="retail<20Input" />
                        <input type="hidden" onClick={metricsFilterHandler} value="retail2140" id="retail2140Input" />
                        <input type="hidden" onClick={metricsFilterHandler} value="retail4160" id="retail4160Input" />
                        <input type="hidden" onClick={metricsFilterHandler} value="retail6180" id="retail6180Input" />
                        <input type="hidden" onClick={metricsFilterHandler} value="retail>81" id="retail>81Input" />
                        <input type="hidden" onClick={metricsFilterHandler} value="franchiseRisk" id="franchiseRiskInput" />
                        <input type="hidden" onClick={metricsFilterHandler} value="nonFranchiseRisk" id="nonFranchiseRiskInput" />
                    </Grid>
                </div>
            </div>
            <TableContainer className='tableUsedStockReport' id="tableStockScroll" onScroll={getScroll}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <th className='stickyHeaderCustom'>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headCellsFixed.map((headCell) => (
                                                <TableCell className={headCell.classLabel}
                                                    key={headCell.id}
                                                    sortDirection={orderBy === headCell.id ? order : false}
                                                    onClick={createSortHandler(headCell.id)}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? order : 'asc'}
                                                        onClick={createSortHandler(headCell.id)}
                                                        >
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </th>
                            <th className={selectTab === "vehicle" ? 'headerCustomFinal' : 'headerCustomFinal hidden'}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headsCellsVehicle.map((headCell) => (
                                                <TableCell className={headCell.classLabel}
                                                    key={headCell.id}
                                                    sortDirection={orderBy === headCell.id ? order : false}
                                                    onClick={createSortHandler(headCell.id)}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? order : 'asc'}
                                                        onClick={createSortHandler(headCell.id)}
                                                        >
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </th>
                            <th className={selectTab === "price" ? 'headerCustomFinal' : 'headerCustomFinal hidden'}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headsCellsPrice.map((headCell) => (
                                                <TableCell className={headCell.classLabel}
                                                    key={headCell.id}
                                                    sortDirection={orderBy === headCell.id ? order : false}
                                                    onClick={createSortHandler(headCell.id)}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? order : 'asc'}
                                                        onClick={createSortHandler(headCell.id)}
                                                        >
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </th>
                            <th className={selectTab === "valuation" ? 'headerCustomFinal' : 'headerCustomFinal hidden'}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headsCellsValuation.map((headCell) => (
                                                <TableCell className={headCell.classLabel}
                                                    key={headCell.id}
                                                    sortDirection={orderBy === headCell.id ? order : false}
                                                    onClick={createSortHandler(headCell.id)}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? order : 'asc'}
                                                        onClick={createSortHandler(headCell.id)}
                                                        >
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </th>
                            <th className={selectTab === "market" ? 'headerCustomFinal' : 'headerCustomFinal hidden'}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headsCellsMarket.map((headCell) => (
                                                <TableCell className={headCell.classLabel}
                                                    key={headCell.id}
                                                    sortDirection={orderBy === headCell.id ? order : false}
                                                    onClick={createSortHandler(headCell.id)}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? order : 'asc'}
                                                        onClick={createSortHandler(headCell.id)}
                                                        >
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </th>
                            <th className={selectTab === "prep" ? 'headerCustomFinal' : 'headerCustomFinal hidden'}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headsCellsPrep.map((headCell) => (
                                                <TableCell className={headCell.classLabel}
                                                    key={headCell.id}
                                                    sortDirection={orderBy === headCell.id ? order : false}
                                                    onClick={createSortHandler(headCell.id)}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? order : 'asc'}
                                                        onClick={createSortHandler(headCell.id)}
                                                        >
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </th>
                            <th className={selectTab === "actions" ? 'headerCustomFinal' : 'headerCustomFinal hidden'}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headsCellsActions.map((headCell) => (
                                                <TableCell className={headCell.classLabel}
                                                    key={headCell.id}
                                                    style={{textAlign: "center"}}
                                                    sortDirection={orderBy === headCell.id ? order : false}
                                                    onClick={createSortHandler(headCell.id)}
                                                >
                                                    <TableSortLabel
                                                        active={orderBy === headCell.id}
                                                        direction={orderBy === headCell.id ? order : 'asc'}
                                                        onClick={createSortHandler(headCell.id)}
                                                        >
                                                        {headCell.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </th>
                        </TableRow>
                    </TableHead>
                    <TableBody className='bodyTableCustom'>
                        {
                            loaderVisible ? (
                                <CircularIndeterminate type="small" />
                            ) : (
                                [...stableSort([...stockData.filterTableData], getComparator(order, orderBy))].map((row, i) => (
                                    <TableRow key={i} className="rowTableCustom" id={"row-"+row.fullChassis}>
                                        <td className='stickyColumnsCustom'>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell className='columnSize60'>
                                                            {extractSiteName(row.site)}
                                                        </TableCell>
                                                        <TableCell className='columnSize80'>
                                                            {row.regNo}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.make}
                                                        </TableCell>
                                                        <TableCell className='columnSize200'>
                                                            {row.model}
                                                        </TableCell>
                                                        <TableCell className='columnSize80'>
                                                            <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                {formatters.CurrencyThousandSeparatorWithoutZero(row.retailPrice)}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell className='columnSize80'>
                                                            <span style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                                {row.mileage}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell className='columnSize60'>
                                                            {row.dis === -400 || row.dis === 400 ? "-" : row.dis}
                                                        </TableCell> 
                                                        <TableCell className='columnSize80'>
                                                        {
                                                            row.progressCode !== 'R' ? canEdit ?
                                                                <>
                                                                    <span onClick={() => updatePrice("row-"+row.fullChassis, row.branchID, row.regNo, row.stockNO, row.retailPrice, row.mileage, row.vehicleDescription, extractSiteName(row.site), row.lastUpdateMileage, row.lasUpdatePrice, row.priceUpdateUser, row.mileageUpdateUser, row.advertiserId, row.stockId, row.atStatus)} className='spanEdit'>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                                                            <path d="M9.29388 3.42704L5.74481 3.44603C3.13134 3.46001 1.02409 5.59943 1.03814 8.22456L1.07627 15.3544C1.09031 17.9795 3.22033 20.0963 5.83379 20.0823L12.9319 20.0443C15.5454 20.0304 17.6526 17.8909 17.6386 15.2658L17.6132 10.5126M13.2995 3.53462L8.29347 9.25727C8.20263 9.3618 8.14925 9.48866 8.14391 9.61266L8.15888 12.348C8.14644 12.637 8.56095 12.9973 8.85999 12.9278L11.5187 12.3102C11.647 12.2804 11.7686 12.2058 11.8595 12.1013L16.9594 5.94779M13.2995 3.53462L15.0178 1.46134C15.4176 1.00121 16.0657 0.87633 16.4652 1.18241L18.4586 2.75209C18.8581 3.05817 18.8579 3.67931 18.4581 4.13944L16.9594 5.94779M13.2995 3.53462C13.713 4.52158 15.024 6.38595 16.9594 5.94779M4.6317 16.5237L14.0959 16.4731" stroke="#3E3E3E" strokeWidth="1.5" strokeLinecap="round" />
                                                                        </svg>
                                                                    </span>
                                                                    <span className='checkedIcon hidden'>
                                                                        <GreenCheck />
                                                                    </span>
                                                                    {
                                                                        isAdm && (row.atStatus === "Published" || row.atStatus === "Not Published") ? <>
                                                                            <span onClick={() => deleteATRecord(row.advertiserId, row.stockId, row.atStatus, row.regNo)} className='spanEdit' style={{marginTop: "5px", marginLeft: "2px"}}>
                                                                                <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M5.12817 8.15391C5.12817 10.4103 5.12817 13.5898 5.12817 15.1283C5.23074 16.4616 5.3333 18.2052 5.43587 19.436C5.53843 20.8719 6.7692 22.0001 8.2051 22.0001H15.7948C17.2307 22.0001 18.4615 20.8719 18.5641 19.436C18.6666 18.2052 18.7692 16.4616 18.8718 15.1283C18.9743 13.5898 18.8718 10.4103 18.8718 8.15391H5.12817Z" fill="#030D45"/>
                                                                                    <path d="M19.1795 5.07698H16.6154L15.7949 3.53852C15.2821 2.61545 14.359 2.00006 13.3333 2.00006H10.8718C9.84615 2.00006 8.82051 2.61545 8.41026 3.53852L7.38462 5.07698H4.82051C4.41026 5.07698 4 5.48724 4 5.8975C4 6.30775 4.41026 6.71801 4.82051 6.71801H19.1795C19.5897 6.71801 20 6.41032 20 5.8975C20 5.38468 19.5897 5.07698 19.1795 5.07698ZM9.12821 5.07698L9.64103 4.25647C9.84615 3.84621 10.2564 3.53852 10.7692 3.53852H13.2308C13.7436 3.53852 14.1538 3.74365 14.359 4.25647L14.8718 5.07698H9.12821Z" fill="#030D45"/>
                                                                                </svg>
                                                                            </span>
                                                                        </> : ""
                                                                    }
                                                                </> : ""
                                                            : <>
                                                                <div className='reservedToolTipWrp' style={{zIndex: "1"}}>
                                                                        <span className="reservedBox">RESERVED</span>
                                                                        <div className='reservedToolTip'>
                                                                            <span className='lineReserved'>Reserved: <span>{row.reservedDateFormatted} - <span>{row.reservedBy}</span> days</span></span>
                                                                            <span className='lineReserved'>By: <span>{row.reservedByName}</span></span>
                                                                            <span className='lineReserved'>Est. Delivery: <span>{row.deliveryDate}</span></span>
                                                                        </div>
                                                                </div>
                                                            </>
                                                        }
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </td>
                                        <td className={selectTab === "vehicle" ? "tableSelect" : "tableSelect hidden"}>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell className='columnSize80'>
                                                            {row.stockNO}
                                                        </TableCell>
                                                        <TableCell className='columnSize250'>
                                                            {row.specification}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {
                                                                row.transmission === "4" || row.transmission === "5" || row.transmission === "6" ? row.transmission + " speed" : row.transmission === "A" ? "Automatic" : row.transmission === "C" ? "CVT" : row.transmission === "S" ? "Semi-automatic" : row.transmission
                                                            }
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {
                                                                row.fuelType == "D" ? "Diesel" : row.fuelType == "E" ? "Electric" : row.fuelType == "H" ? "Hybrid" : row.fuelType == "L" ? "LPG" : row.fuelType == "M" ? "Plug-in Hybrid" : row.fuelType == "O" ? "Others" : row.fuelType == "P" || row.fuelType == "U" ? "Petrol" : row.fuelType
                                                            }
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.colour}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.modelCode}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.dor !== null && row.dor !== "0001-01-01T00:00:00" ? row.dor.toString().slice(0, 10).split("-").reverse().join("/") : "-"}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.inStockDate !== null && row.inStockDate !== "0001-01-01T00:00:00" ? row.inStockDate.toString().slice(0, 10).split("-").reverse().join("/") : "-"}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.qualifyingForVAT}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.progressCode}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.acsStatus}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {row.supplier}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </td>
                                        <td className={selectTab === "price" ? "tableSelect" : "tableSelect hidden"}>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell className='columnSize95'>
                                                            {row.pricePosition !== null ? row.pricePosition + "%" : "-"}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            <PriceIndicator indicator={row.atPriceIndicator}  />
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {row.daysSinceChange}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.noOfChanges}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.lastPriceChange)}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.totalPriceChange)}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.standInValue)}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.total)}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.margin)}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </td>
                                        <td className={selectTab === "valuation" ? "tableSelect" : "tableSelect hidden"}>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell className='columnSize120'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.atRetailValue)}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            <span className={row.atVariance < 0 ? "redValue" : "greenValue"}>{formatters.CurrencyThousandSeparatorWithoutZero(row.atVariance)}</span>
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.capClean)}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            <span className={row.capVariance < 0 ? "redValue" : "greenValue"}>{formatters.CurrencyThousandSeparatorWithoutZero(row.capVariance)}</span>
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.standInValue)}
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.daysToSell}
                                                        </TableCell>
                                                        {/* <TableCell className='columnSize120'>
                                                           {formatters.CurrencyThousandSeparatorWithoutZero(row.forecastValuation)}
                                                        </TableCell> */}
                                                        <TableCell className='columnSize80'>
                                                           <span style={row.capId !== null ? {cursor: "pointer"} : {cursor: "pointer", color: "rgb(237, 76, 60)"}} onClick={() => openCapPopup(row.usedVehicleStockID)}>{row.capId !== null ? row.capId : "No Code"}</span>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </td>
                                        <td className={selectTab === "market" ? "tableSelect" : "tableSelect hidden"}>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell className='columnSize95'>
                                                            <RetailRating rating={row.atRetailRating} />
                                                        </TableCell>
                                                        <TableCell className='columnSize150'>
                                                            <PerformanceRating indicator={row.atPerformanceRating}  />
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            <PriceIndicator indicator={row.atPriceIndicator}  />
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {row.daysToSell}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {row.marketCondition}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {row.attentionGrabber}
                                                        </TableCell>
                                                        <TableCell className='columnSize80'>
                                                            {row.photos}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {row.atAdvertViews}
                                                        </TableCell>
                                                        <TableCell className='columnSize100'>
                                                            {row.atStatus}
                                                        </TableCell>
                                                        <TableCell className='columnSize100'>
                                                            {
                                                                row.taxonomyCheck === "Not checked" ? <>
                                                                    <span id={row.fullChassis} style={{cursor: "pointer", color: "rgb(237, 76, 60)"}} onClick={() => { openAutotraderTaxonomyPopup(row.fullChassis, row.advertiserId, row.make, row.modelCode, row.branchID); }}>{row.taxonomyCheck}</span>
                                                                </> : <>
                                                                    <span style={{cursor: "auto"}}>{row.taxonomyCheck}</span>
                                                                </>
                                                            }
                                                        </TableCell>
                                                        <TableCell className='columnSize95'>
                                                            {
                                                                row.atLink !== "noLink" ? <>
                                                                    <a href={row.atLink} title='AT Ad Link' target='_blank' style={{textDecoration: 'none', color: '#4871D9'}}>AT Ad Link</a>
                                                                </> : <>
                                                                    <span>No Link</span>
                                                                </>
                                                            }
                                                        </TableCell>
                                                        {/* <TableCell className='columnSize120'>
                                                            <a href={row.chorleyLink} title='CG Ad Link' target='_blank' style={{textDecoration: 'none', color: '#4871D9'}}>CG Ad Link</a>
                                                        </TableCell> */}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </td>
                                        <td className={selectTab === "prep" ? "tableSelect" : "tableSelect hidden"}>
                                        <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell className='columnSize120'>
                                                            {row.estDate}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {row.vehiclePrep}
                                                        </TableCell>
                                                        <TableCell className='columnSize120'>
                                                            {row.daysToPrep}
                                                        </TableCell>
                                                        <TableCell className='columnSize150'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.estimatedMechPrep)}
                                                        </TableCell>
                                                        <TableCell className='columnSize150'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.actualMechPrep)}
                                                        </TableCell>
                                                        <TableCell className='columnSize150'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.estimatedBodywork)}
                                                        </TableCell>
                                                        <TableCell className='columnSize150'>
                                                            {formatters.CurrencyThousandSeparatorWithoutZero(row.actualBodywork)}
                                                        </TableCell>
                                                        <TableCell className='columnSize150'>
                                                            {row.motExpiry !== null && row.motExpiry !== "0001-01-01T00:00:00" ? row.motExpiry.toString().slice(0, 10).split("-").reverse().join("/") : "-"}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </td>
                                        <td className={selectTab === "actions" ? "tableSelect" : "tableSelect hidden"}>
                                            <Table>
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell className='columnSize80' style={{textAlign: "center"}}>
                                                            {row.noPrice ? <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                        <TableCell className='columnSize80' style={{textAlign: "center"}}>
                                                            {row.noPhotos ? <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                        <TableCell className='columnSize100' style={{textAlign: "center"}}>
                                                            {row.noMileage ? <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                        <TableCell className='columnSize80' style={{textAlign: "center"}}>
                                                            {row.toPrep ? <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                        <TableCell className='columnSize80' style={{textAlign: "center"}}>
                                                            {row.noPrepPush ? <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                        <TableCell className='columnSize80' style={{textAlign: "center"}}>
                                                            {row.priceChange ? <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                        <TableCell className='columnSize80' style={{textAlign: "center"}}>
                                                            {row.noTaxonomy ? <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                        <TableCell className='columnSize120' style={{textAlign: "center"}}>
                                                            {row.reserved10 ?  <RedCheck /> : <GreenCheck />}
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </td>
                                    </TableRow>
                                ))
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}